var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "48px_school",
    clipPath: "url(#clip0_18_1098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0001 7.58333V1.08333H17.3334V4.33333H13.0001",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.1667 24.9167V19.5H10.8334V24.9167",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.4167 16.25V11.9167L13 7.58334L7.58337 11.9167V16.25H1.08337V24.9167H24.9167V16.25H18.4167Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.50004 19.5H4.33337V21.6667H6.50004V19.5Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.0834 13.5417H11.9167V15.7083H14.0834V13.5417Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.6667 19.5H19.5001V21.6667H21.6667V19.5Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.a0677b4aefe5228ea5daf94064ff45c9.svg";
export { ForwardRef as ReactComponent };